import { cn } from '@askable/ui/lib/utils';
import { Plus } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { CreateStudy as CreateStudyBase } from 'src/containers/Root/components/CreateStudy';

import { menuItemClass, menuItemCollapsedClass } from './MenuItem';

export const CreateStudy = ({ isCollapsed }: { isCollapsed: boolean }) => {
  const { t } = useTranslation();

  const trigger = (
    <button
      className={cn(menuItemClass, 'aria-expanded:bg-foreground/[0.065] aria-expanded:text-foreground', {
        [`${menuItemCollapsedClass} hover:bg-transparent focus:bg-transparent aria-expanded:bg-transparent`]:
          isCollapsed,
      })}
    >
      <div
        className={cn(
          // 20px: a touch larger than the 16px icon box its siblings use, since this
          // is the one row that's an action rather than a destination. Centred on
          // their axis all the same, so the column still reads as one line.
          //
          // --background only has headroom over the rail while the row is at rest.
          // Hovered or open, the row's own wash rises past it and the chip inverts
          // into a hole — it vanished exactly when you reached for it. --accent
          // clears the lit row too, so the circle holds in every state.
          `shrink-0 rounded-full bg-background p-0.5 shadow-sm transition-transform group-hover/menuitem:scale-110 group-focus-visible/menuitem:scale-110 dark:bg-accent`,
          { 'shadow-md': isCollapsed },
        )}
      >
        {/* Full foreground rather than the row's resting nav colour: the glyph sits on
            its own circle, so it should not dim and brighten with the row around it. */}
        <Plus className="size-4 text-foreground" />
      </div>
      <div
        className={cn('truncate whitespace-nowrap opacity-100 transition-opacity duration-150', {
          'w-0 opacity-0': isCollapsed,
        })}
      >
        {t('sections.navigation.createNew')}
      </div>
    </button>
  );

  return (
    <CreateStudyBase
      trigger={trigger}
      title={t('sections.navigation.createNew')}
      isCollapsed={isCollapsed}
      align="start"
      side="right"
    />
  );
};
